import { Location } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import {
  allowedImageFormats,
  isLargeScreen,
  uploadedFileCheck,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { AddEditClientComponent } from '../../../../shared/components/add-edit-client/add-edit-client.component';
import { AddEditSiteComponent } from '../../../../shared/components/add-edit-site/add-edit-site.component';
import { ClientSiteContactsComponent } from '../../../../shared/components/client-site-contacts/client-site-contacts.component';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ContactComponent } from '../../../../shared/components/contact/contact.component';
import { EventSchedulerComponent } from '../../../../shared/components/event-scheduler/event-scheduler.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { companyTableDetails } from '../../tableDetails';
import { UsersService } from '../../users/users.service';
import { ClientsService } from '../clients.service';

@Component({
  selector: 'gtapp-view-client',
  templateUrl: './view-client.component.html',
  styleUrl: './view-client.component.scss',
  standalone: false,
})
export class ViewClientComponent implements OnInit, OnDestroy {
  @ViewChild('addNewPrimeContractorUser') addNewPrimeContractorUser: any;
  detailData: any = [];
  clientDetailData: any;

  siteListData: any = [];

  clientId: any;
  selectedEvent: any;

  userEventDetailsTableView = companyTableDetails?.desktopTable;
  clientHistory: any = [];

  dialogref: any;

  reportRecipientList: any = [];

  isAdmin: boolean = this.dataCheckService.isUserAdmin();
  isDispatchUser: boolean = this.dataCheckService.isDispatchUser();

  newInfromation: any;
  patrolReportSchedules: any = [];
  clientFiles: any = [];

  uploadFile: any;
  fileUploadError: any;
  fileDescription: any;

  slicedClientFiles: any = [];

  largeView: Boolean = isLargeScreen;

  primeContractorUserForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    first_name: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/.*\S.*/),
    ]),
    last_name: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/.*\S.*/),
    ]),
    display_name: new UntypedFormControl(''),
    contact_number: new UntypedFormControl(''),
  });

  constructor(
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private dataCheckService: DataCheckService,
    private userService: UsersService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private _location: Location,
  ) {
    this.clientId = this.route.snapshot.paramMap.get('cKey');
    this.getCustomerDetailById();
    const routeFragment: any = this.route.snapshot.fragment;
    if (['jc', 'pc'].includes(routeFragment)) {
      this.scrollToReportSection(`#${routeFragment}`);
    }
  }
  ngOnDestroy(): void {
    this.appService.removeToolTips();
  }

  ngOnInit(): void {
    if (this.route.snapshot.fragment === 'userAdded') {
      this.router.navigate([
        '/view-client',
        {
          cKey: this.clientId,
        },
      ]);
      this.createNewPrimeContractorUser();
    }
  }
  scrollToReportSection(containerId: any) {
    setTimeout(() => {
      const idElement = document.querySelector(containerId);

      if (idElement) {
        idElement?.scrollIntoView();
      }
    }, 200);
  }
  getClientHistoryData() {
    this.clientService
      .getCompanyDetailById(this.clientId, { get_history: 1 })
      .subscribe((response: any) => {
        this.clientHistory = response?.data || [];
      });
  }

  formatData(response: any) {
    this.clientDetailData = response;
    this.appService.initializeBootstrapTooltips();

    this.detailData = response?.data;

    this.siteListData = this.clientDetailData?.sites || [];

    this.reportRecipientList =
      this.clientDetailData?.report_recipients?.slice(0, 3) || [];
    this.patrolReportSchedules =
      this.clientDetailData?.patrol_report_schedules || [];

    this.clientFiles = this.clientDetailData?.company_files || [];
    this.slicedClientFiles = this.clientFiles?.slice(0, 3);

    this.spinnerService.hide();
    if (this.isAdmin && this.largeView) this.getClientHistoryData();
  }
  onTableRowClick(event: any) {
    this.selectedEvent = event;

    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 100);
  }

  getCustomerDetailById() {
    this.spinnerService.show();
    this.clientService
      .getCompanyDetailById(this.clientId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatData(response);
        } else {
          this.spinnerService.hide();
        }
      });
  }

  addNewSite() {
    this.dialogref = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: {
          company: this.detailData?.id,
          clientName: this.detailData?.company_name,
        },
      },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.getCustomerDetailById();
      }
    });
  }
  openJobView() {
    this.router.navigate(['/jobs', { clientId: this.clientId }]);
    sessionStorage.setItem(
      'fromClient',
      JSON.stringify({
        client: {
          id: this.detailData?.id,
          company_name: this.detailData?.company_name,
        },
      }),
    );
  }
  openCPView() {
    this.router.navigate(['/checkpoints', { clientId: this.clientId }]);
    sessionStorage.setItem(
      'fromClient',
      JSON.stringify({
        client: {
          id: this.detailData?.id,
          company_name: this.detailData?.company_name,
        },
      }),
    );
  }
  openReportView() {
    sessionStorage.setItem('selectedTab', 'Scheduled Reports');
    this.router.navigate(['/reports'], {
      queryParams: {
        clientInfo: btoa(
          JSON.stringify({
            id: this.detailData?.id,
            company_name: this.detailData?.company_name,
          }),
        ),
      },
    });
  }

  openSiteView(siteData: any) {
    this.router.navigate(['/view-site', { sKey: String(siteData?.id) }]);
  }
  showAllSites() {
    this.router.navigate([
      '/sites',
      {
        clientId: this.clientId,
      },
    ]);
  }

  openEditTemplate() {
    this.dialogref = this.dialogService.open(AddEditClientComponent, {
      data: { updateView: true, companyData: this.detailData },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      this.spinnerService.hide();
      if (value !== false) {
        this.formatData(value);
      }
    });
  }

  openJobReportContactTemplate() {
    if (this.isAdmin || this.isDispatchUser) {
      const dialogRef = this.dialogService.open(ClientSiteContactsComponent, {
        data: {
          clientData: this.detailData,
          selectedUsers: JSON.parse(
            JSON.stringify(this.clientDetailData?.report_recipients || []),
          ),
        },
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        if (res?.data?.id) {
          this.formatData(res);
        } else {
          this.getCustomerDetailById();
        }
      });
    }
  }

  openSiteContactTemplate(data: any, clientData: any, contactType: any) {
    this.dialogref = this.dialogService.open(ContactComponent, {
      data: {
        contactData: data,
        clientData: clientData,
        contactType: contactType,
      },
    });
    this.dialogref.afterClosed().subscribe((dialogResponse: any) => {
      if (dialogResponse !== false) {
        this.getCustomerDetailById();
      }
    });
  }

  openSchedulerTemplate(schedule?: any) {
    this.dialogref = this.dialogService.open(EventSchedulerComponent, {
      data: { clientData: this.detailData, scheduleData: schedule },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.formatData(value);
      }
    });
  }
  openInformationTemplate(template: any) {
    this.newInfromation = this.detailData?.information;
    this.dialogref = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
  }

  openFileUploadTemplate(template: any) {
    this.fileUploadError = null;
    this.fileDescription = null;
    this.dialogref = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }

  updateClientInformation() {
    this.spinnerService.show();
    this.clientService
      .updateClient(
        this.detailData?.id,
        {
          information: this.newInfromation,
        },
        { update_information: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }

  async handleFileInput(event: any) {
    let file = event?.target?.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    this.fileUploadError = await uploadedFileCheck(
      fileExtension,
      fileSize,
      1024 * 1024 * 8,
      ['pdf', ...allowedImageFormats],
    );
    if (!this.fileUploadError) {
      this.uploadFile = event?.target?.files.item(0);
    }
  }

  onUploadFile() {
    if (this.uploadFile) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', this.uploadFile);
      fileData.append('upload_files', '1');
      fileData.append('description', this.fileDescription);

      this.appService
        .formDataApi(`company/${this.detailData?.id}/update`, fileData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatData(response);

            this.fileUploadError = null;
            this.fileDescription = null;
            this.uploadFile = null;
            this.spinnerService.hide();
          } else {
            this.fileUploadError = null;
            this.fileDescription = null;
            this.uploadFile = null;
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
        });
    }
  }
  onOpenFile(file: any) {
    if (file?.extension === '.pdf') {
      this.downloadFile(file);
    } else {
      this.dialogService.open(
        MediaPreviewComponent,
        {
          data: { mediaSrc: file?.file_url },
        },
        this.viewContainerRef,
      );
    }
  }

  downloadFile(file: any) {
    const a = document.createElement('a');
    a.href = file?.file_url;
    a.download = `${file?.name}${file?.extension}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  deleteClientFile(file: any) {
    this.clientService
      .updateClient(this.detailData?.id, {
        file_id: file?.id,
        delete_file: 1,
      })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatData(response);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
  deleteFile(file: any) {
    let dialogMsg = `Permanently delete file: ${file.description}`;
    this.dialogref = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Delete File`,
        message: dialogMsg,
      },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.deleteClientFile(file);
      }
    });
  }
  archiveUnarchive() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `${this.detailData?.is_active ? 'Delete' : 'Restore'}  Client `,
        message: `${
          this.detailData?.is_active
            ? 'Deleting this client will mean sites will become unavailable when adding new jobs.'
            : 'Restore client'
        } `,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.clientService
          .enableDisableCompanyById(this.detailData?.id)
          .then((response: any) => {
            if (response?.status == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              this._location.back();
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }

  shiftFocus(elementId: string, time?: number) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, time);
  }

  selectFile() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }
  openCamPopup() {
    var button: any = document.getElementById('clientLogoInput');
    button.click();
  }

  async handleClientLogoInput(item: any) {
    let file = item.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheckError = await uploadedFileCheck(fileExtension, fileSize);
    if (fileCheckError) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: fileCheckError,
      });
    } else {
      this.onFileSubmit(item.files.item(0));
    }
  }
  onFileSubmit(file: any) {
    if (file) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', file);
      fileData.append('upload_logo', '1');

      this.appService
        .formDataApi(`company/${this.detailData?.id}/update`, fileData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatData(response);
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
          this.spinnerService.hide();
        });
    }
  }
  removeClientLogo() {
    this.dialogref = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Remove Logo`,
        message: '',
      },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        this.clientService
          .updateClient(this.detailData?.id, {
            remove_logo: 1,
          })
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.formatData(response);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
            this.spinnerService.hide();
          });
      }
    });
  }
  async showAllJobsToPCUsers(event: any) {
    this.clientService
      .updateClient(this.detailData?.id, {}, { pc_show_all_jobs: 1 })
      .then((response: any) => {
        this.appService.removeToolTips();
        if (response['status'] == 'success') {
          this.formatData(response);
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  async updateSubContractorStatus(event: any) {
    const checked = event.target.checked;

    if (!checked && this.clientDetailData?.prime_contractor_users?.length) {
      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: ``,
          message: 'This will also remove their login.',
        },
      });
      const res = await firstValueFrom(dialogRef.afterClosed());
      if (!res) {
        event.target.checked = this.detailData?.is_subcontracting;
        return;
      }
    }
    this.spinnerService.show();

    this.clientService
      .updateClient(this.detailData?.id, {}, { update_subcontracting: 1 })
      .then((response: any) => {
        this.appService.removeToolTips();
        if (response['status'] == 'success') {
          this.formatData(response);
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  async isPermanentSlotAvailable(): Promise<boolean> {
    this.spinnerService.show('Fetching data');
    const response: any = await lastValueFrom(
      this.userService.getUserListData({ get_count: 1 }),
    );

    return (
      (response?.allotted_slots || 0) >
      (response?.total_permanent_user_count || 0)
    );
  }
  async createNewPrimeContractorUser() {
    this.primeContractorUserForm.reset();
    const permanentSlotsAvailable =
      this.dataCheckService.isFreeAccessAccount() ||
      (await this.isPermanentSlotAvailable()) ||
      false;
    this.spinnerService.hide();
    const dialogRef = this.dialogService.open(
      this.addNewPrimeContractorUser,
      {
        data: {
          permanentSlotsAvailable,
          isSubscriberAdmin: this.dataCheckService?.isSubscriberAdmin(),
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      this.clientService
        .updateClient(this.detailData?.id, this.primeContractorUserForm.value, {
          manage_prime_contractor_users: 1,
          add_user: 1,
        })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatData(response);
            this.spinnerService.hide();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
            this.spinnerService.hide();
          }
        });
    }
  }
  async removePrimeContractorUser(user: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Remove User`,
        message: '',
      },
    });
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res === true) {
      this.clientService
        .updateClient(
          this.detailData?.id,
          { user_ids: [user?.id] },
          {
            manage_prime_contractor_users: 1,
            remove_user: 1,
          },
        )
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.formatData(response);
            this.spinnerService.hide();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
            this.spinnerService.hide();
          }
        });
    }
  }
  clearField(fieldId: string) {
    this.primeContractorUserForm.controls[fieldId].setValue('');
    this.shiftFocus(fieldId);
  }
  updateDisplayName() {
    if (
      this.primeContractorUserForm.value?.first_name &&
      this.primeContractorUserForm.value?.last_name
    ) {
      const fullName =
        `${(this.primeContractorUserForm.value?.first_name || '')?.trim()} ${(this.primeContractorUserForm.value?.last_name || '')?.trim()}`?.trim();
      if (fullName)
        this.primeContractorUserForm.controls['display_name'].setValue(
          fullName,
        );
    }
  }
  mobileNumberCheck() {
    if (!this.primeContractorUserForm.value?.contact_number) {
      this.primeContractorUserForm.controls['contact_number'].setValue(null);
      this.primeContractorUserForm.controls['contact_number'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.primeContractorUserForm.controls['contact_number'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }
  addMoreUserSlots() {
    this.router.navigate(['/subscription'], {
      fragment: 'addUser',
      queryParams: { cId: this.detailData?.id },
    });
  }
  emailExistsCheck() {
    this.userService
      .getUserListData({
        rows: 1,
        search_filters: JSON.stringify({
          user__email: this.primeContractorUserForm.value?.email,
        }),
      })
      .subscribe((response: any) => {
        if (response?.data?.length) {
          const controls = this.primeContractorUserForm.controls['email'];
          controls.setErrors({
            ...controls.errors,
            alreadyExists: true,
          });
        }
      });
  }
}
